export interface IUser {
    username: string;
    role: USER_ROLE;
    name: string | null;
    email: string | null;
    full_name: string;
    linkedin_profile_url: string | null
    disabled: boolean;
    microsoft_id: string | null;
    last_seen_at: Date | string | null;
    client_id: string | null;
    id: string;
    access_token: string | null;
    client: IClient | null;
    auth_method: string | null;
    token_expires_at: Date;
    accessible_clients?: IClientAccessSlim[];
}

export interface IUserCondensed {
    username: string;
    role: USER_ROLE;
    name: string | null;
    email: string | null;
    full_name: string;
    linkedin_profile_url: string | null
    disabled: boolean;
    last_seen_at: Date | string | null;
    client_id: string | null;
    id: string;
    /** True when this tenant is the user's primary org; false when listed via multi-client grant. */
    is_primary_client?: boolean;
}

export interface IUserProfileMinimal {
    id: string;
    name: string | null;
    full_name: string;
}

export type WhitelistInviteAuthMethod = 'PASSWORD' | 'SSO';

export interface IWhitelistUser {
    email: string;
    client_id: string | null;
    role: USER_ROLE;
    linkedin_profile_url: string | null;
    created_at: Date;
    whitelist_id: string;
    status?: 'INVITED' | 'ACTIVE';
    invited_at?: Date | null;
    last_invite_sent_at?: Date | null;
    invite_auth_method?: WhitelistInviteAuthMethod;
    sales_leaders?: IUserProfileMinimal[];
}

export interface IClient {
    name: string;
    domain: string;
    address: string | null;
    privacy_policy: string | null;
    client_type_id: number;
    id: number;
    industry_id: number | null;
    service_enabled?: boolean;
    billing_setup_requested_at?: string | null;
    billing_setup_effective_at?: string | null;
    billing_setup_coupon_id?: string | null;
}

export interface IReqLogin {
    username: string;
    password: string;
    email?: string;
}

export interface DispatchAuth {
    type: string;
    payload?: any;
}

export enum USER_ROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    SALES_REP = 'SALES_REP',
    SALES_LEADER = 'SALES_LEADER',
    CLIENT_ADMIN = 'CLIENT_ADMIN'
}

export interface IToken {
    access_token: string,
    token_type: string
}

export interface IClientAccessSlim {
    id: string;
    name: string;
    domain: string;
    subscription_tier?: string;
    billing_period?: string;
    service_enabled?: boolean;
}

export interface GrantUserClientRequest {
    client_id: string;
}

export interface IUserRead extends IUser {
    accessible_clients?: IClientAccessSlim[];
}

export interface IClientLimitStatus {
    effective_limits: {
        max_accounts: number;
        max_active_accounts_per_user?: number;
        max_contacts_per_account: number;
        max_industries: number;
        max_topics?: number;
        max_competitors?: number;
        max_users: number;
        /** Derived cap on create + unarchive events per UTC calendar month. */
        monthly_account_creation_budget?: number;
    };
    current_usage: {
        accounts: number;
        industries: number;
        topics?: number;
        competitors?: number;
        users: number;
        contacts_per_account_max: number;
        /** CREATE + UNARCHIVE activation events in the current UTC month. */
        new_accounts_this_period?: number;
    };
    limits_status: {
        accounts: boolean;
        industries: boolean;
        topics?: boolean;
        competitors?: boolean;
        users: boolean;
        contacts_per_account: boolean;
        new_accounts_this_period?: boolean;
    };
    subscription_tier: string;
    has_overrides: boolean;
    module?: string | null;
    capabilities?: Record<string, boolean>;
}

